import React, { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { $getSelection, $isRangeSelection } from "lexical";

export default function CustomLinkPlugin(): React.JSX.Element {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Add click handler for links
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the clicked element is a link or has a link parent
      let linkElement: HTMLElement | null = null;

      if (target.tagName === 'A') {
        linkElement = target;
      } else {
        // Check if parent is a link (for nested elements)
        linkElement = target.closest('a');
      }

      if (linkElement && linkElement.getAttribute('href')) {
        event.preventDefault();
        event.stopPropagation();
        const url = linkElement.getAttribute('href');
        console.log('Link clicked:', url);
        if (url) {
          // Open link in new tab
          window.open(url, '_blank', 'noopener,noreferrer');

          // Move cursor away from the link to prevent prefilling dialog
          setTimeout(() => {
            editor.update(() => {
              const selection = $getSelection();
              if ($isRangeSelection(selection)) {
                // Move cursor to the end of the current paragraph
                const anchorNode = selection.anchor.getNode();
                const parent = anchorNode.getParent();
                if (parent) {
                  parent.selectEnd();
                }
              }
            });
          }, 10);
        }
      }
    };

    // Add the event listener to the editor for link clicks only
    const editorElement = editor.getRootElement();
    if (editorElement) {
      editorElement.addEventListener('click', handleLinkClick, true);
    }

    return () => {
      if (editorElement) {
        editorElement.removeEventListener('click', handleLinkClick, true);
      }
    };
  }, [editor]);

  return (
    <LinkPlugin validateUrl={(url: string) => {
      // Validate URLs - return true if valid, false if invalid
      try {
        // Add protocol if missing
        let validUrl = url;
        if (validUrl && !validUrl.match(/^https?:\/\//)) {
          validUrl = 'https://' + validUrl;
        }

        // Basic URL validation
        new URL(validUrl);
        return true; // Valid URL
      } catch {
        return false; // Invalid URL
      }
    }} />
  );
}
